import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
} from 'vue';
import ChatHistoryUi from '@/components/ChatInterface/ChatHistory/ChatHistoryUi.vue';
import ChatNavigation from '@/components/ChatInterface/ChatNavigation.vue';
import ChatThreadUi from '@/components/ChatInterface/ChatThread/ChatThreadUi.vue';
import ContactSupportUi from '@/components/ChatInterface/ContactSupport/ContactSupportUi.vue';
import {
  type ConversationThreadService,
  getConversationThreadService,
} from '@/services/ConversationThreadService';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatInterface',
  setup(__props) {


let conversationThreadService: ConversationThreadService;

const utilStore = useStore.util;
const conversationHistoryStore = useStore.conversationHistory;

onMounted(async () => {
  conversationThreadService = getConversationThreadService();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ChatNavigation),
    _withDirectives(_createVNode(ChatHistoryUi, null, null, 512), [
      [_vShow, _unref(conversationHistoryStore).showHistoryList]
    ]),
    (!_unref(conversationHistoryStore).showHistoryList)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(utilStore).isSupportOn)
            ? (_openBlock(), _createBlock(ContactSupportUi, { key: 0 }))
            : (_openBlock(), _createBlock(ChatThreadUi, { key: 1 }))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})